import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { LettereDiffidaEsitoSpedizioneAddComponent } from './lettere-diffida-esito-spedizione-add.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [lettere-diffida-esito-spedizione-add-mod]',
  templateUrl: 'lettere-diffida-esito-spedizione-add-mod.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class LettereDiffidaEsitoSpedizioneAddMod {
  @Output() onReturn: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild('formEsitoSpedizione') formEsitoSpedizione: LettereDiffidaEsitoSpedizioneAddComponent;

  inizializza(urlAddEsitoSpedizione: string, idLetteraDiffida: string, idSezioneEventi: string) {
    this.formEsitoSpedizione.inizializza(urlAddEsitoSpedizione, idLetteraDiffida, idSezioneEventi);
    openModal('modalmodesitispedizione');
  }

  createForm() {
    this.formEsitoSpedizione.createForm();
  }

  manageModal() {
      closeModal('modalmodesitispedizione');
      this.onReturn.emit();
  }
}
